import type { Role, UserWithAccessAndRole } from '../types/MilestoneMap1';

/**
 * Minimal map shape needed to resolve a role. Structurally satisfied by MilestoneMap1.
 */
export type RoleResolvableMap = {
  owner: { uid: string };
  usersWithAccess?: Array<Pick<UserWithAccessAndRole, 'uid' | 'role'>>;
};

/**
 * Pure role resolution for a user on a map.
 *
 * - map owner uid match -> 'owner' (takes precedence over usersWithAccess)
 * - otherwise the role from the first usersWithAccess entry with that uid
 * - otherwise null (no access)
 * - missing map or missing/empty uid -> null
 *
 * No logging and no side effects; callers decide how to report null.
 */
export function resolveRole(
  map: RoleResolvableMap | null | undefined,
  uid: string | null | undefined,
): Role | null {
  if (!map || !uid) return null;
  if (map.owner.uid === uid) return 'owner';
  const access = map.usersWithAccess?.find((u) => u.uid === uid);
  return access ? access.role : null;
}
